import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["posSpecificFields", "replicationGroupSelect", "advancedOptions", "toggleIcon"];

  connect() {
    // Manually initialize the fields if we already have a value
    if (this.hasReplicationGroupSelectTarget && this.replicationGroupSelectTarget.value) {
      this.replicationGroupChanged();
    }
  }

  toggleAdvancedOptions() {
    if (!this.hasAdvancedOptionsTarget || !this.hasToggleIconTarget) {
      return;
    }

    if (this.advancedOptionsTarget.classList.contains("hidden")) {
      // Expand
      this.advancedOptionsTarget.classList.remove("hidden");
      this.toggleIconTarget.textContent = "▼"; // Down arrow when expanded
    } else {
      // Collapse
      this.advancedOptionsTarget.classList.add("hidden");
      this.toggleIconTarget.textContent = "▶"; // Right arrow when collapsed
    }
  }

  replicationGroupChanged(event) {
    if (!this.hasReplicationGroupSelectTarget || !this.hasPosSpecificFieldsTarget) {
      return;
    }

    const replicationGroupId = this.replicationGroupSelectTarget.value;
    const formElement = this.element.closest("form");
    const familySwitchPlanId = formElement.getAttribute("action").split("/").pop();
    get(
      `/admin/family_switch_plans/pos_fields?replication_group_id=${replicationGroupId}&family_switch_plan_id=${familySwitchPlanId}`,
      { responseKind: "turbo-stream" }
    );
  }
}
